import React from "react";
import Maps_branches from "../../containers/Maps_branches";

export default function Index() {
    return (
        <div>
            <Maps_branches  />
        </div>
    );
}
